<svelte:options accessors/>
<script>
    import {createEventDispatcher} from "svelte";

    let dispatch = createEventDispatcher();
    let country = '';
    export let countries = [];

    export let isActive = true;

    function selectCountry() {
        dispatch('country', country);
    }
</script>
<div class="sendModal" class:hide={!isActive}>
    <div class="sendContainer">
        <div class="modalClose" on:click={() => {isActive = false;}}>x</div>
        <div class="py-2">
            <h3>Bienvenido a nuestro portafolio de productos</h3>
            <p>Selecciona el país del cuál deseas ver el&nbsp;portafolio:</p>
            <form action="" name="countrySelector" id="countrySelector">
                <div class="singleinput">
                    <label for="contactType">Selecciona País</label>
                    <div class="formSelect">
                        <select name="contactType" id="contactType" bind:value={country}>
                            <option value="" hidden=""></option>
                            {#each countries as countryItem}
                                <option value="{countryItem.slug}">{countryItem.name}</option>
                            {/each}
                        </select>
                    </div>
                    <span class="placeholder" class:hide={!!country}>Seleccionar...</span>
                    <!-- <div class="errorInput">Debes seleccionar tipo de contacto</div> -->
                </div>
            </form>
            <a on:click={selectCountry}>Ver portafolio</a>
        </div>
    </div>
</div>
<style>
    .py-2 {
        padding-left: 2rem;
        padding-right: 2rem;
    }

    .hide {
        display: none !important;
    }
</style>
<!--
<style>
    .hide {
        display: none !important;
    }

    /* products.css */
    .singleinput {
        display: flex;
        flex-direction: column;
        margin-bottom: 1rem;
    }

    .singleinput span {
        position: absolute;
        margin-top: 2rem;
        margin-left: 1rem;
        color: #C4C4C4;
    }

    .singleinput select {
        background-color: #F9F9F9;
        font-family: 'NeoSans-R';
        font-size: 0.9rem;
        color: #6E6E6E;
        padding: 0.5rem;
        border: 1px solid #DEDEDF;
        border-radius: 5px;
        outline: none;
        position: relative;
    }

    .singleinput label {
        color: #6E6E6E;
        margin-bottom: 0.2rem;
        font-family: 'NeoSans-M';
        text-align: left;
    }

    .formSelect {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .formSelect select {
        width: 100%;
        background-image: url('../imgs/products/down-arrow.svg');
        background-repeat: no-repeat;
        background-position: 98% 50%;
    }

    .formSelect img {
        position: absolute;
        padding-right: 0.5rem;
    }

    .singleinput select {
        cursor: pointer;
        -moz-appearance: none;
        -webkit-appearance: none;
    }


    .sendModal {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, .4);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 14;
        /* display: none; */
    }

    .sendModal .sendContainer {
        width: 91%;
        /* height: 35vh; */
        max-width: 450px;
        background: #fff;
        text-align: center;
        padding-bottom: 3.5rem;
    }

    .sendModal .sendContainer form {
        width: 77%;
        margin: 2.1em auto;
    }

    .sendModal .sendContainer p {
        text-align: center;
        color: #6E6E6E;
        font-size: 1.1rem;
        width: 84%;
        max-width: 300px;
        margin: 0 auto 1.4rem;
    }

    .sendModal .sendContainer h3 {
        font-family: 'NeoSans-B';
        color: #56B1DE;
        font-size: 1.6rem;
        margin: .6rem 0;
    }

    .sendModal .sendContainer a {
        background-color: #56B1DE;
        padding: .6rem 0 .4rem;
        color: #FFFFFF;
        font-family: 'NeoSans-R';
        font-size: 1.3rem;
        outline: none;
        border: none;
        border-radius: 5px;
        display: block;
        width: 84%;
        margin: auto;
        max-width: 270px;
    }

    .sendModal img {
        margin-top: 2.8rem;
        margin-right: 3.7rem;
    }

    .sendModal .modalClose {
        height: 35px;
        width: 35px;
        color: #707070;
        text-transform: uppercase;
        text-align: center;
        line-height: 2;
        font-size: 21px;
        font-weight: bold;
        margin-left: auto;
        cursor: pointer;
        margin-top: 0.3rem;
        margin-right: .3rem;
    }

    @media screen and (min-width: 1024px) {
        .sendModal img {
            width: 200px;
            margin-top: 4.2rem;
        }

        .sendModal .sendContainer h3 {
            font-size: 30px;
            margin-top: 2.1rem;
        }

        .sendModal .sendContainer a {
            font-size: 1rem;
        }

        .sendModal .sendContainer p {
            margin: 1.4rem auto .7rem;
        }

        .sendModal .sendContainer {
            padding-bottom: 4.9rem;
        }
    }
</style>
-->